import React, { Component } from "react";
import PropTypes from "prop-types";
import { Parallax } from "../../node_modules/react-parallax/dist/index";

class Splash extends Component {
  static propTypes = {
    imageSrc: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    photographer: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className="container parallaxContainer">
        <Parallax bgImage={this.props.imageSrc} bgHeight="700px" strength={400}>
          {" "}
          {/*bgHeight=the height of the background image, strength=The strength of the parallax effect*/}
          <div style={{ height: "475px" }} />{" "}
          {/*Sets the hight of the visible parallax window*/}
          <div
            className="card"
            style={{ width: 18 + "rem", margin: 20 + "px" }}
          >
            <div className="card-body">
              <h4 className="card-title">{this.props.title}</h4>
              <p className="card-text">By {this.props.photographer}</p>
            </div>
          </div>
          <br />
        </Parallax>
      </div>
    );
  }
}

export default Splash;



// WEBPACK FOOTER //
// ./src/components/splash.jsx